// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3151":"495541c9","3613":"495541c9"}[chunkId] + ".chunk.css";
};